module.exports = __webpack_public_path__ + "img/huawuIcon.dea80ef9.png";